import React from "react";
import { InstagramLogo, ShoppingBag, ChartLineUp } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_live-invoice-hub/artifacts/hg8sz0o4_herida.jpg";

export default function Login() {
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-brand-bg grid lg:grid-cols-2">
      {/* Hero image */}
      <div className="hidden lg:block relative border-r-2 border-brand-ink overflow-hidden bg-brand-bg">
        <img
          src={HERO_IMAGE}
          alt="Desapegue com Herida"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>

      {/* Login card */}
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 bg-brand-pink border-2 border-brand-ink shadow-brutal flex items-center justify-center">
              <ShoppingBag weight="bold" size={22} color="#F8F0D8" />
            </div>
            <div>
              <h1 className="font-heading text-3xl font-black leading-none">LiveHub</h1>
              <p className="text-xs uppercase tracking-widest text-brand-ink2">Desapegue com Herida</p>
            </div>
          </div>

          <div className="card-brutal p-8 animate-fade-in">
            <h2 className="font-heading text-3xl font-black">Entrar</h2>
            <p className="text-brand-ink2 mt-2">
              Anote pedidos, cobre em segundos e concilie o extrato bancário sem dor de cabeça.
            </p>

            <button
              data-testid="google-login-button"
              onClick={handleLogin}
              className="btn-pink w-full mt-8"
            >
              <InstagramLogo weight="bold" size={20} />
              Entrar com Google
            </button>

            <div className="mt-8 space-y-3">
              <Feature icon={<ChartLineUp weight="bold" size={18} />} text="Pedidos em tempo real durante a live" />
              <Feature icon={<ShoppingBag weight="bold" size={18} />} text="Mensagem de cobrança automática" />
              <Feature icon={<InstagramLogo weight="bold" size={18} />} text="Conciliação bancária por CSV/OFX" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Feature({ icon, text }) {
  return (
    <div className="flex items-center gap-3">
      <div className="w-8 h-8 bg-brand-yellow border-2 border-brand-ink flex items-center justify-center">{icon}</div>
      <span className="text-sm font-bold">{text}</span>
    </div>
  );
}
